module.exports = __webpack_public_path__ + "img/pilipenko.23335fac.jpg";